/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Prospects_Probabilityweightedmidpoint4Inputs */

const en_coinvestments_prospects_probabilityweightedmidpoint4 = /** @type {(inputs: Coinvestments_Prospects_Probabilityweightedmidpoint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probability Weighted Mid Point`)
};

/**
* | output |
* | --- |
* | "Probability Weighted Mid Point" |
*
* @param {Coinvestments_Prospects_Probabilityweightedmidpoint4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_prospects_probabilityweightedmidpoint4 = /** @type {((inputs?: Coinvestments_Prospects_Probabilityweightedmidpoint4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Prospects_Probabilityweightedmidpoint4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_prospects_probabilityweightedmidpoint4(inputs)
});
export { coinvestments_prospects_probabilityweightedmidpoint4 as "coInvestments_prospects_probabilityWeightedMidPoint" }